/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import {ProductInfo} from "@insite/client-framework/Common/ProductInfo";
import {Handler, replaceInChain} from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadLists
} from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import {getWishListsDataView} from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";

interface Parameter {
    productInfos?: Omit<ProductInfo, "productDetailPath">[];
    modalIsOpen: boolean;
}

type HandlerType = Handler<Parameter>;

export const XngLoadLists: HandlerType = props => {
    const state = props.getState();
    const getWishListsParameter = state.components.addToListModal.getWishListsParameter;
    const session = state.context.session;

    if (
        props.parameter.modalIsOpen &&
        (session.isAuthenticated || session.rememberMe) &&
        !getWishListsDataView(state, getWishListsParameter).value
    ) {
        props.dispatch(loadWishLists(getWishListsParameter));
    }
};

replaceInChain(chain, LoadLists, XngLoadLists);